<template>
  <div>
    <v-card min-height="550">
      <col-skeleton-loader v-if="loading" :clms="4"></col-skeleton-loader>
      <v-row width="100%" v-if="!loading">
        <v-col cols="6">
          <v-card class="pa-2 green2 elevation-0">
            <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
            <v-list class="green2">
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-subtitle
                    >{{$t('dashboardS.damID')}}
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{$t('animal.conceptionInfo.damIdH')}}</span>
                    </v-tooltip>
                  </v-list-item-subtitle>
                  <v-list-item-title class="text-h6 mt-2">
                    {{ animal.damPubId ? animal.damPubId : $t('notSpecified') }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card class="pa-2 green2 elevation-0">
            <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
            <v-list class="green2">
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-subtitle
                    >{{$t('dashboardS.sireId')}}
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{$t('animal.conceptionInfo.sireIdH')}}</span>
                    </v-tooltip>
                  </v-list-item-subtitle>
                  <v-list-item-title class="text-h6 mt-2">
                    {{ animal.sirePubId ? animal.sirePubId : $t('notSpecified') }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card class="pa-2 green2 elevation-0">
            <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
            <v-list class="green2">
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-subtitle
                    >{{$t('dashboardS.srgDamId')}}
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{$t('animal.conceptionInfo.sarogatedDamH')}}</span>
                    </v-tooltip>
                  </v-list-item-subtitle>
                  <v-list-item-title class="text-h6 mt-2">
                    {{
                      animal.surrogateDamPubId
                        ? animal.surrogateDamPubId
                        : $t('notSpecified')
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card class="pa-2 green2 elevation-0">
            <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
            <v-list three-line class="green2">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle
                    >{{$t('animal.twin')}}
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{$t('animal.animalHasATwinOrNot')}} </span>
                    </v-tooltip>
                  </v-list-item-subtitle>
                  <v-list-item-title class="text-h6 mt-2">
                    {{ animal.twin ? $t('yes') : $t('no') }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>
<script>
import ColSkeletonLoader from "@/components/col-skeleton-loader.vue";
export default {
  components: {
    ColSkeletonLoader,
  },
  created() {},
  watch: {
    animal: function () {
      this.loading = false;
      console.log("ss", this.animal);
    },
  },
  data() {
    return {
      currentAnimal: {},
      loading: true,
    };
  },
  props: ["animal"],
};
</script>